export interface IProps {
  open: boolean;
  onClose: () => void;
  content: React.ReactNode;
  handleOK?: () => void;
  handleCancel?: () => void;
  modalHeader?: React.ReactNode;
  size?: "modal-sm" | "modal-lg" | "modal-xl"
  id?: string;
  modalFooter?: React.ReactNode;
}

export function Modal(props: IProps) {
  const { open, onClose, handleOK, handleCancel, content, modalHeader, size, id, modalFooter } = props;

  return (
    <div>
      <div
        className={"modal fade" + (open ? " show" : "")}
        id={id? id : "exampleModal"}
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className={"modal-dialog modal-dialog-centered " + (size? size: "")}>
          <div className="modal-content">
            <div className="modal-header" style={{alignItems: 'baseline'}}>
              {modalHeader && modalHeader}
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">{content}</div>
            <div className="modal-footer">
              {modalFooter ? modalFooter : 
              <>
                {handleCancel && (
                <button
                  type="button"
                  className="default-btn btn-cancel"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    handleCancel();
                    onClose();
                  }}
                >
                  Cancel
                </button>
              )}

              {handleOK && (
                <button
                  type="button"
                  className="default-btn btn-ok"
                  onClick={() => {
                    handleOK();
                    onClose();
                  }}
                >
                  OK
                </button>
              )}
              </>
            }
              
            </div>
          </div>
        </div>
      </div>
      <div className={open ? "modal-backdrop show" : ""}></div>
    </div>
  );
}
